const custom_pt = require('./custom.json')
export default custom_pt